import { Box } from "@mui/material";
import CampaignIcon from "@mui/icons-material/Campaign";
import clsx from "clsx";

interface IUnreadNotificationProps {
	unreadNotifications: number | string;
	onUnreadNotificationClick?: () => void;
}

export default function UnreadNotification(props: Readonly<IUnreadNotificationProps>) {
	if (!props.unreadNotifications || props.unreadNotifications === 0) {
		return null;
	}

	return (
		<Box
			className={clsx({
				"flex flex-row cursor-pointer": true,
				"rounded-[25px] ml-auto !py-[2px]": true,
				"font-montserrat font-medium text-white text-[12px]/[20px] text-center tracking-[.4px]": true,
				"bg-gradient-to-r from-[#0000ff] to-[#3db2ff]": true,
			})}
			onClick={props.onUnreadNotificationClick}
		>
			<span className="ml-[11px] mr-[3px]">{props.unreadNotifications} Unread</span>
			<CampaignIcon className="mr-[10px]" fontSize="small" />
		</Box>
	);
}
